import React from 'react';
import BaseModal from './BaseModal';
import { Button } from '../buttons/button';
import { ICONS } from '../../constants/imageConstants';

const LocationPermissionModal = ({ isOpen, onClose, type = 'denied' }) => {
  const isUnavailable = type === 'unavailable';

  const handleReloadClick = () => {
    window.location.reload();
  };

  const title = isUnavailable ? "Turn on Device Location" : "Turn on location access";
  const subtitle = isUnavailable 
    ? "Your device location is turned off. Please enable GPS to continue."
    : "Allow location for this site in your browser, then reload this page to continue.";

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      icon={ICONS.LOCATION_PIN}
      iconBgColor="#EEF2FF"
    >
      <div className="px-6 pb-6">
        <div className="bg-gray-50 rounded-lg p-4 mb-6 border border-gray-200 text-left">
          <h4 className="text-sm font-semibold text-gray-800 mb-2">
            {isUnavailable ? 'How to enable GPS' : 'How to enable permission'}
          </h4>
          {isUnavailable ? (
            <ol className="text-sm text-gray-600 list-decimal ml-5 space-y-1.5">
              <li>Open your device <strong>Settings</strong>.</li>
              <li>Tap on <strong>Location</strong>.</li>
              <li>Switch it to <strong>On</strong>.</li>
              <li>Return here and click <strong>Reload page</strong>.</li>
            </ol>
          ) : (
            <ol className="text-sm text-gray-600 list-decimal ml-5 space-y-1.5">
              <li>Open the site information or permissions menu in your browser address bar.</li>
              <li>Find the Location permission for this site.</li>
              <li>Change the setting to Allow for this site.</li>
              <li>Return here and use the button below to reload the page.</li>
            </ol>
          )}
        </div>
        <div className="flex gap-3">
          <Button
            onClick={onClose}
            variant="secondary"
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={handleReloadClick}
            variant="primary"
            className="flex-1"
          >
            Reload page
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default LocationPermissionModal;